import ISvgProps from '../../../SvgLoader/ISvgProps';

function SvgElectronics(props: ISvgProps) {
	return (
		<svg width={60} height={60} fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#Electronics_svg__a)">
				<path
					d="M50.63 16.563a1.015 1.015 0 1 0 0-2.032h-6.663a1.015 1.015 0 1 0 0 2.031h6.663ZM27.524 47.325c0 1.354-2.031 1.354-2.031 0 0-1.353 2.031-1.353 2.031 0Z"
					fill={props.secondaryColor}
				/>
				<path
					d="M5.455 52.496h15.173l-.853 4.835h-7.11a1.015 1.015 0 1 0 0 2.03h27.768a1.015 1.015 0 1 0 0-2.03h-7.11l-.792-4.835h15.163a3.91 3.91 0 0 0 3.9-3.9V24.445a3.91 3.91 0 0 0-3.9-3.9H5.454a3.901 3.901 0 0 0-3.9 3.9v24.151a3.902 3.902 0 0 0 3.9 3.9Zm25.848 4.835h-9.456l.843-4.835h7.81l.803 4.835Zm16.392-6.866H5.455a1.869 1.869 0 0 1-1.869-1.869v-3.788h45.978v3.789a1.868 1.868 0 0 1-1.869 1.868ZM5.455 22.576h42.24a1.87 1.87 0 0 1 1.869 1.87v18.331H3.587V24.496a1.867 1.867 0 0 1 1.869-1.92Z"
					fill={props.primaryColor}
				/>
				<path
					d="M54.62 9.443H39.986a4.833 4.833 0 0 0-4.834 4.835v3.26a1.015 1.015 0 1 0 2.031 0v-3.26a2.802 2.802 0 0 1 2.803-2.803h14.636a2.803 2.803 0 0 1 2.793 2.803v40.249a2.803 2.803 0 0 1-2.793 2.803h-9.557a1.015 1.015 0 1 0 0 2.031h9.557a4.834 4.834 0 0 0 4.824-4.834v-40.25a4.834 4.834 0 0 0-4.824-4.834Z"
					fill={props.secondaryColor}
				/>
			</g>
			<defs>
				<clipPath id="Electronics_svg__a">
					<path fill="#fff" d="M0 0h60v60H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}

export default SvgElectronics;
